<template>
  <div>
    <main-layout>
      <div>
        <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
          <v-tab href="#dashboard" ripple>{{ $t('Dashboard') }}</v-tab>
          <v-tab
            href="#customersatisfaction"
            v-if="selectedBot && selectedBot.pageid == '100207768987988'"
            ripple
            >{{ $t('Customer Satisfaction') }}</v-tab
          >
          <v-tab
            v-if="![...$store.state.rabbitReplyFBPostPage].includes(selectedBot.pageid)"
            href="#agent"
            ripple
            >{{ $t('Agent View') }}
          </v-tab>
          <v-tab href="#funnel" ripple>{{ $t('Funnel View') }}</v-tab>
          <v-tab
            href="#rabbit-agent-performance"
            ripple
            v-if="[...$store.state.rabbitReplyFBPostPage].includes(selectedBot.pageid)"
          >
            {{ $t('Agent Performance') }}
          </v-tab>
          <v-tab
            href="#users"
            ripple
            v-if="$store.state.privilege && $store.state.privilege.agent_management"
            >{{ $t('Admin/Agent User Management') }}</v-tab
          >
          <v-tab
            v-if="
              selectedBot && ['100207768987988', '102052945584054'].includes(selectedBot.pageid)
            "
            href="#workinghours"
            ripple
            >Working Hours</v-tab
          >
        </v-tabs>
        <div :key="currentView"><component v-if="!loading" :is="currentView"></component></div>
        <div style="height: 60px"></div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Dashboard from './Dashboard'
import Agent from './Agent'
import Funnel from './Funnel'
import Users from './Users'
import customersatisfaction from './CustomerSatisfaction'
import Workinghours from './WorkingHour.vue'
import RabbitAgentPerformance from './RabbitReplyFBPost/AgentPerformance.vue'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      currentView: 'dashboard',
      loading: true
    }
  },
  components: {
    Dashboard,
    Agent,
    Funnel,
    Users,
    customersatisfaction,
    Workinghours,
    RabbitAgentPerformance
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'dashboard':
        case 'customersatisfaction':
        case 'agent':
        case 'funnel':
        case 'users':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'dashboard'
          break
      }
    } else {
      vm.currentView = 'dashboard'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('loadAgents')
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    this.loading = false
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'ticket',
        path: '/ticket',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/main.vue